module.exports = __webpack_public_path__ + "img/icon-calendar-active.23718388.svg";